export const getCheckout = store => store.checkout;
export const getShippingMethods = store => getCheckout(store).shippingMethods;
export const getPaymentMethods = store => getCheckout(store).paymentMethods;
